module.exports = __webpack_public_path__ + "static/img/zjff_zt.0a511dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qh/zjff_zt.png
// module id = 4rxY
// module chunks = 1